/* eslint-disable no-unused-vars */
import React from 'react';
import {
  FluentProvider,
} from '@fluentui/react-components';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { PortalCompatProvider } from '@fluentui/react-portal-compat';

// we need to add a fluentprovider here since PortalCompatProvider needs it, and without it we
// cannot get v9 styles to work in v8 surfaces such as Dialog, Panel.
// we set display to contents here since we don't want to add a div to the DOM
export const withThemeProvider = (WrappedComponent) => {
  const HoC = React.forwardRef((props, ref) => (
    <FluentProvider style={{ display: 'contents' }}>
      <PortalCompatProvider>
        <WrappedComponent {...props} />
      </PortalCompatProvider>
    </FluentProvider>
  ));

  HoC.displayName = `withFluentSwitcher(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HoC, WrappedComponent);

  return HoC;
};
